function numberWithCommas(x){
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function gauge(v){
    let val = '';
    if( v == 0 ) return;
    if( v <= 1000 ){
        val = v * 0.043
    }
    else if( v <= 5000 ){
        val = v * 0.045
    }
    else if( v <= 19999 ){
        val = v * 0.046
    }
    else {
        val = 918;
    }

    $('.battery__point span').text( numberWithCommas(v) );
    $('.battery__gauge').css({'width': val+'px'});
}

export default gauge;


// WEBPACK FOOTER //
// ./src/js/components/gauge.js